import axios from 'redux/actions/cgAxios'
import makeCancelable from 'app/common/hoc/make-cancelable/makeCancelable'

export default(request) => {
  return makeCancelable(axios({
    ...request
  }))
}
